import React from "react";
import PreviousResult from "./PreviousResult";
import { locales } from "../../locales";
import { Close } from "../../assets";

const TooltipContent = ({ details, langId, style }) => {
  let data;
  // console.log(details);
  if (details) {
    data = [
      {
        year: 2023,
        votes: details.votesReceived2023 ? details.votesReceived2023 : 0,
      },
      {
        year: 2017,
        votes: details.votesReceived2017 ? details.votesReceived2017 : 0,
      },
      {
        year: 2011,
        votes: details.votesReceived2011 ? details.votesReceived2011 : 0,
      },
      {
        year: 2005,
        votes: details.votesReceived2005 ? details.votesReceived2005 : 0,
      },
      {
        year: 1999,
        votes: details.votesReceived1999 ? details.votesReceived1999 : 0,
      },
      {
        year: 1993,
        votes: details.votesReceived1993 ? details.votesReceived1993 : 0,
      },
      {
        year: 1987,
        votes: details.votesReceived1987 ? details.votesReceived1987 : 0,
      },
      {
        year: 1981,
        votes: details.votesReceived1981 ? details.votesReceived1981 : 0,
      },
    ];
  }

  if (!data) {
    return null;
  }
  return (
    <div
      className="relative p-2 bg-white shadow text-white w-[375px]"
      style={style}
    >
      <div className="absolute top-2 right-2 cursor-pointer">
        <Close />
      </div>
      <div className="flex flex-col pl-3">
        <span className="text-black leading-6 font-medium">
          {locales[langId].previousCandidacies}
        </span>
        <div className="flex flex-row items-center">
          <div
            className="w-[17px] h-[13px]"
            style={{ backgroundColor: "#006692" }}
          ></div>
          <span className="ml-2 text-xs leading-5 text-black">
            {locales[langId].votesReceived}
          </span>
        </div>
        <div className="flex flex-col" style={{ height: 150 }}>
          <PreviousResult data={data} langId={langId} />
        </div>
      </div>

      <div className="absolute w-3 h-3 bg-white -bottom-1 left-2 transform rotate-45"></div>
    </div>
  );
};

export default TooltipContent;
